<script>
    import { onMount } from "svelte";
    import { Router, Link, Route } from "svelte-routing";
    import { recipes } from "../stores";
</script>

<Router>
    <ul>
        {#each $recipes as recipe}
            <li><Link to={recipe.slug}>{recipe.name}</Link></li>
        {/each}
    </ul>
    <div />
</Router>
